/** A full-screen, autoplaying YouTube trailer lightbox. Shared by the details
 *  overlay and the swipe card. Uses youtube-nocookie + a referrer policy to
 *  dodge YouTube Error 153 on embeds. Tap the backdrop or ✕ to close. */
export function extractYouTubeId(url: string): string | null {
  try {
    const u = new URL(url);
    // https://www.youtube.com/watch?v=XYZ
    const v = u.searchParams.get("v");
    if (v) return v;
    // https://youtu.be/XYZ
    if (u.hostname === "youtu.be") return u.pathname.slice(1);
  } catch {
    return null;
  }
  return null;
}

export function TrailerLightbox({ youtubeId, onClose }: { youtubeId: string; onClose: () => void }) {
  return (
    <div className="trailer-bg" onClick={onClose}>
      <button className="trailer-close" onClick={onClose} aria-label="Close trailer">
        ✕
      </button>
      <iframe
        data-testid="trailer-embed"
        className="trailer-frame"
        src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1`}
        allow="autoplay; encrypted-media"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
        onClick={(e) => e.stopPropagation()}
        title="Trailer"
      />
    </div>
  );
}
